import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-gdo-payment-container',
    templateUrl: './gdo-payment-container.component.html',
    styleUrls: ['./gdo-payment-container.component.scss'],
    standalone: false
})
export class GdoPaymentContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
